<ng-container *ngFor="let data of shownData; let i = index; let l = last; let f = first">
  <ng-template *ngTemplateOutlet="child; context: { data: data, index: i, first: f, last: l }"></ng-template>
</ng-container>
<a
  *ngIf="allData.length > sliceLength && sliceLength >= 0"
  class="expandable-list__button mat-primary cursor-pointer"
  [ngClass]="buttonClass"
  [style]="buttonStyle"
  (click)="areShownAll ? hideAll() : showAll()"
>
  {{ interpolate(areShownAll ? hideText : showText) }}
</a>
